import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getExperienceBasicInfo } from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { isOnsiteUpsellBuilder } from "@src/store/slices/experienceBuilder/common/selectors/isOnsiteUpsellBuilder";
import {
  getNewOnsiteUpsellComponents,
  markCreatedOnsiteUpsellsReported,
  selectedReportedCreatedOnsiteUpsellIds,
} from "@src/store/slices/experienceComponents";
import { mpOnsiteUpsellCreationCompleted } from "@src/utils/mixpanel";
import { getOnsiteUpsellMpProperties } from "@src/utils/mpUtils";

// Fired once the builder persists the upsell (Save, or Save-on-exit) — the
// first point `surface` and `has_discount` are known. Dispatch AFTER `saveMods`
// so the component slice reflects the just-built config. Only newly created
// upsells emit here (one event each); saving an edit to an existing upsell is
// covered by `onsite_upsell_edited`, not a second creation event.
export const trackOnsiteUpsellCreationCompleted = createAsyncThunk<void, void>(
  "experienceBuilder/tracking/onsiteUpsellCreationCompleted",
  (_, { dispatch, getState }) => {
    const state = getState();
    if (!isOnsiteUpsellBuilder(state)) return;

    const trackedComponentIds = new Set(
      selectedReportedCreatedOnsiteUpsellIds(state)
    );
    const components = getNewOnsiteUpsellComponents()(state).filter(
      (component) => !trackedComponentIds.has(component.id)
    );
    if (components.length === 0) return;

    const experienceInfo = getExperienceBasicInfo(state);
    const newlyTrackedComponentIds: string[] = [];

    components.forEach((component) => {
      const { componentId, surface, hasDiscount, upsellType } =
        getOnsiteUpsellMpProperties(component);

      mpOnsiteUpsellCreationCompleted({
        componentId,
        surface,
        hasDiscount,
        upsellType,
        experienceId: experienceInfo?.experienceId,
      });
      newlyTrackedComponentIds.push(componentId);
    });

    dispatch(markCreatedOnsiteUpsellsReported(newlyTrackedComponentIds));
  }
);
